
/**
 * 트윗 유형
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
